import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import UpdateBanner from './components/UpdateBanner';
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <App />
        <UpdateBanner />
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Enregistrement du Service Worker PWA pour le mode hors-ligne et l'installabilité
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker PWA enregistré avec succès ! Scope:', registration.scope);

        // Quand un nouveau Service Worker prend le contrôle → recharger avec la nouvelle version
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload();
        });

        let newWorker = null;

        // Notifier l'interface qu'une nouvelle version est prête à être activée
        const notifyUpdateReady = () => {
          window.dispatchEvent(new CustomEvent('comptaai-update-ready', {
            detail: { registration, worker: newWorker }
          }));
        };

        // Une mise à jour est déjà en attente (nouvelle visite avec SW installé)
        if (registration.waiting) {
          newWorker = registration.waiting;
          notifyUpdateReady();
          return;
        }

        // Suivre le SW en cours d'installation
        const trackInstalling = (worker) => {
          if (!worker) return;
          newWorker = worker;
          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              notifyUpdateReady();
            }
          });
        };

        trackInstalling(registration.installing);
        registration.addEventListener('updatefound', () => trackInstalling(registration.installing));
      })
      .catch((error) => {
        console.warn('⚠️ Échec enregistrement Service Worker PWA:', error);
      });
  });
}
